import { useCallback, useMemo } from 'react'
import { observe } from '~/services/observability/observe'
import {
  AnalyticsEventFromNamespace,
  AnalyticsNamespace,
} from '~/types/Analytics'

/**
 * React entry point for observe.track. Delegates to the per-namespace
 * Analytics instance; the returned object is referentially stable so it
 * can appear in dependency arrays without forcing re-runs.
 */
export const useAnalytics = <TNamespace extends AnalyticsNamespace>(
  namespace: TNamespace,
) => {
  const track = useCallback(
    (
      name: AnalyticsEventFromNamespace<TNamespace>,
      data?: Record<string, unknown>,
    ) => {
      observe.track(namespace, name, data)
    },
    [namespace],
  )

  return useMemo(() => ({ track }), [track])
}
